import React from 'react';
import PropTypes from 'prop-types';
import BracketMatch from '@views/BracketMatch';
import { Bracket as BracketType } from '@models/Match';

import './BracketGrid.css';

const RoundCard = ({ title, matches, variant, useParrilla }) => (
  <div className={`bracket-round-card bracket-round-card--${variant}`}>
    <div className="bracket-round-card__header">{title}</div>
    <div className="bracket-round-card__body">
      {(matches || []).map((match = {}, i) => (
        <BracketMatch key={match.mid || i} {...match} parrillaRow={!!useParrilla} />
      ))}
    </div>
  </div>
);

RoundCard.propTypes = {
  title: PropTypes.string.isRequired,
  matches: PropTypes.array,
  variant: PropTypes.string,
  useParrilla: PropTypes.bool,
};

RoundCard.defaultProps = {
  matches: [],
  variant: 'default',
  useParrilla: false,
};

/**
 * Parrilla Mundial 2026 (Principal.jpg): dieciseisavos → … → final en tarjetas.
 */
const BracketGrid = ({ forward: fw, reverse: rev, final: fin }) => {
  const [finalMatch] = fin || [];
  const thirdPlaceMatch = fin?.[1];

  return (
    <div className="bracket-grid">
      <div className="bracket-grid__row bracket-grid__row--top">
        <RoundCard
          title="Dieciseisavos"
          matches={fw.roundof32}
          variant="early"
          useParrilla
        />
        <RoundCard
          title="Dieciseisavos"
          matches={rev.roundof32}
          variant="early"
          useParrilla
        />
      </div>
      <div className="bracket-grid__row bracket-grid__row--middle">
        <RoundCard title="Octavos" matches={fw.roundof16} variant="octavos" />
        <RoundCard title="Cuartos" matches={fw.quarter} variant="early" />
        <RoundCard title="Semi final" matches={fw.semi} variant="semi" />
        <div className="bracket-center-column">
          <RoundCard
            title="Final"
            matches={finalMatch ? [finalMatch] : []}
            variant="final"
          />
          <RoundCard
            title="Tercero"
            matches={thirdPlaceMatch ? [thirdPlaceMatch] : []}
            variant="final"
          />
        </div>
        <RoundCard title="Semi final" matches={rev.semi} variant="semi" />
        <RoundCard title="Cuartos" matches={rev.quarter} variant="early" />
        <RoundCard title="Octavos" matches={rev.roundof16} variant="octavos" />
      </div>
    </div>
  );
};

BracketGrid.propTypes = {
  [BracketType.Forward]: PropTypes.object.isRequired,
  [BracketType.Reverse]: PropTypes.object.isRequired,
  final: PropTypes.array,
};

export default BracketGrid;
